import React from 'react';

import {makeStyles} from '@material-ui/core/styles';
import CustomTable from '../../common/CustomTable';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
  },
}));

export default function UsersList(props) {
  const {
    users,
    userNames,
    handleEditClick,
    handleUsersChange,
    handleStatusChange,
    statusNames,
    statusList,
    handleSearch,
    handleEdit,
    handleClear,
    selectNames,
    headCells,
    rowList,
    setRowList,
    productsAmount,
    handleMore,
    page,
    setPage,
    handleRequestSort,
    sortProperty,
    sortDirection,
    rowsPerPage,
    setRowsPerPage,
    getFullList,
  } = props;
  const classes = useStyles();

 

  const cellList = headCells.map((cell) => {
    return cell.id;
  });



  return (
    <div className={classes.root}>
      <CustomTable
        data={users.usersList}
        actionsLists={[statusList]}
        actionsHandleChange={[handleStatusChange]}
        actionsNames={[statusNames]}
        headCells={headCells}
        cellList={cellList}
        handleEditClick={handleEditClick}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEdit={handleEdit}
        area={'user'}
        selectNames={selectNames}
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        productsAmount={productsAmount}
        handleMore={handleMore}
        page={page}
        setPage={setPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullList}
      />
    </div>
  );
}
